/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_ReopenInputs */

const vi_einvoice_reopen = /** @type {(inputs: Einvoice_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở lại`)
};

/**

* @param {Einvoice_ReopenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_reopen = /** @type {((inputs?: Einvoice_ReopenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_ReopenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_reopen(inputs)
});